import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import Dashboard from '../../views/Dashboard/';
import Follow from '../../views/Follow/Follow';
import Log from '../../views/Log/Log';
import Template from '../../views/Template/Template';
import Report from '../../views/Report/Report';
import CreateReport from '../../views/Report/CreateReport';
import Send from '../../views/Send/Send';
import AccountsDetail from '../../views/AccountManagement/AccountDetail';

import { urlapi, CheckTokenExp } from '../../config';


class Full extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1"),
            username: "",
            menulist: [],
        };

        this.getToken = this.getToken.bind(this);
        this.validateToken = this.validateToken.bind(this);
        this.validateMenu = this.validateMenu.bind(this);
    }

    componentDidMount() {
        this.getToken();
    }

    getToken() {
        var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1")
        if (token == "") {
            this.props.history.push("/logout");
        } else {
            this.validateToken(token);
        }
        return "";
    }
    validateToken(token) {
        if (!CheckTokenExp()) {

            fetch(urlapi + "api/ValidateToken", {
                crossDomain: true,
                method: 'POST',
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                },
                body: JSON.stringify(token)
            })
                .then(function (data) {
                    if (data.ok) {
                        data.json().then(function (json) {
                            //this.props.history.push("/dashboard");
                            this.setState({ username: json.username, accountId: json.accountid, logo: json.logo });
                            this.validateMenu(json.accountid);
                        }.bind(this));
                    } else {
                        this.props.history.push("/logout");
                    }
                }.bind(this));
        } else {
            this.props.history.push("/logout");
        }

    }

    validateMenu(account) {
        if (account != "") {

            fetch(urlapi + "api/ValidateMenu", {
                crossDomain: true,
                method: 'POST',
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                },
                body: JSON.stringify(account)
            })
                .then(function (data) {
                    if (data.ok) {
                        data.json().then(function (json) {
                            //this.props.history.push("/dashboard");
                            this.setState({ menulist: json });
                        }.bind(this));
                    } else {
                        this.props.history.push("/logout");
                    }
                }.bind(this));
        } else {
            this.props.history.push("/logout");
        }

    }

    render() {
        return (
            <div className="app">
                <Header {...this.props} accountId={this.state.accountId} logo={this.state.logo} username={this.state.username} />
                <div className="app-body">
                    <Sidebar menu={this.state.menulist} {...this.props} />
                    <main className="main">
                        <Container fluid s>
                            <Switch>
                                <Route path="/dashboard" name="Dashboard" component={Dashboard} />
                                <Route path="/report/log" name="Log" component={Log} />
                                <Route path="/follow" name="Follow" component={Follow} />
                                <Route path="/template" name="Template" component={Template} />
                                <Route exact path="/report/" name="Report" component={Report} />
                                <Route path="/report/new" name="CreateReport" component={CreateReport} />
                                <Route path="/send" name="Send" component={Send} />
                                <Route path="/accountmanagement" name="AccountsDetail" component={AccountsDetail} />
                                <Redirect from="/" to="/dashboard" />
                            </Switch>
                        </Container>
                    </main>
                </div>
            </div>
        );
    }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js